// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Router from "next/router";
import ReactMarkdown from "react-markdown";
import * as Config$PorterinUtils from "../../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as AuthStore$PorterinFeature from "../../../domain/store/AuthStore.mjs";
import * as AuthContextV1$PorterinFeature from "../../../view-model/contexts/auth-context/AuthContextV1.mjs";
import * as LoginTncModuleScss from "../../styles/LoginTnc.module.scss";
import * as CategoryAnalytics$PorterinFeature from "../../../../fare-estimate-v1/domain/helpers/CategoryAnalytics.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../../../shared/core/helpers/PublishEventsHelper.mjs";

var styles = LoginTncModuleScss;

function LoginTncCmp(Props) {
  var router = Router.useRouter();
  var match = AuthContextV1$PorterinFeature.useAuthContext(undefined);
  var agreed_docs = match.agreed_docs;
  var getTncContent = function (param) {
    if (Config$PorterinUtils.agreed_docs_login_flag && agreed_docs !== undefined) {
      return AuthStore$PorterinFeature.Login.get_login_agreed_docs(agreed_docs.tnc_url, agreed_docs.privacy_policy_url);
    } else {
      return AuthStore$PorterinFeature.Login.login_tnc;
    }
  };
  return React.createElement("div", {
              className: styles["tnc-wrapper"],
              onClick: (function (param) {
                  PublishEventsHelper$PorterinFeature.publishEvents(CategoryAnalytics$PorterinFeature.getCategoryName(router), AuthStore$PorterinFeature.Login.ga_tnc_tap, undefined);
                })
            }, React.createElement(ReactMarkdown, {
                  children: getTncContent(undefined)
                }));
}

var make = LoginTncCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
